<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <br>
                    <CRow>

                        <CCol col="3">
                            <CSelect
                                    :label="$t('tables.type')"
                                    horizontal
                                    :value.sync="selected_type_parent"
                                    :options="types_parent"
                            />
                        </CCol>

                    </CRow>
                    <CCardBody v-show="selected_type_parent==16">
                        <!--                        <ReportGrid :fields="fields" :items="items_customer"/>-->

                        <BuyReportAllSuppliers/>

                    </CCardBody>

                    <CCardBody v-show="selected_type_parent==11">
                        <!--                        <ReportGrid :fields="fields" :items="items_customer"/>-->

                        <BuyReportOnePerson/>

                    </CCardBody>


                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from "vue";
    import Treeselect from '@riophae/vue-treeselect'

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'
    import BTabs from "../../tabs/BTabs";

    import BuyReportAllSuppliers from "../orders/BuyReportAllSuppliers";
    import BuyReportOnePerson from "../orders/BuyReportOnePerson";
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    export default {
        name: 'Login',
        components: {
            Treeselect,
            BuyReportAllSuppliers,
            BuyReportOnePerson,
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                VUE_APP_Currency: localStorage.getItem('currency'),
                items_customer: [],
                start_date: '',
                end_date: '',

                types_all: [],
                types_parent: [],
                selected_type_parent: 0,
                selected_type_child: 0,

                fields: [//amount amountNegetive accBalance accBalanceNegetive
                    {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},

                    {key: 'masterId', label: this.$t('documentType'), _style: 'width:10%'},
                    {key: 'kardexAccTypeTitle', label: this.$t('reference'), _style: 'width:10%'},

                    {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
                    {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],
                normalizer_accounting(node) {
                    return {
                        id: node.id,
                        label: node.accountCode + " " + node.accountName,
                    }
                },
                normalizer_accounting_tafzili(node) {
                    return {
                        id: node.recId,
                        label: node.title,
                    }
                },
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', false);
                            formData.append('IsCustomer', true);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.fullName+" "+node.mobileNo,
                    }
                },
                templates_items: [],
                accounting_list: [],
                moein_list: [],
                tafsili_list: [],
                selected_person: null,
                selected_moein: null,
                selected_tafsili: null,
                collapseDuration: 0,
                person_name: '',
                status_form: 0
            }
        }, mounted() {

            this.$root.root_validate_errors = [];
            // this.get_lists_groups();
            this.get_types();

            // this.get_lists();
            this.start_date = this.get_day_before_today(1);
            this.end_date = this.get_today();
            bus.$on("report_select_one_supplier", (data) => {
                // alert(data);
                this.selected_type_parent = 11;
                // this.sync_person = false;
                // this.person_async_list= [{userId:data.personId,personCode:data.personCode,fullName:data.personName+" "+data.surName}];
                // setTimeout(() => {
                //   this.selected_person = data.personId;
                //   this.get_lists();
                // }, 300);
                // setTimeout(() => {
                //   this.sync_person = true;
                // }, 1000);
            });

        }, watch: {
            'selected_tafsili': function () {
                // this.get_lists();
            }
        },
        methods: {
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            get_sum_debtor(list) {
                var sum =0;
                list.forEach((val)=>{
                    sum+=parseFloat(val.amountNegetive.replace(/,/g, ''));
                })
                return sum;
            },
            get_sum_credetor(list) {
                var sum =0;
                list.forEach((val)=>{
                    sum+=parseFloat(val.amount.replace(/,/g, ''));
                })
                return sum;
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.unitName;
                this.color = item.color;
                this.description = item.description;
                this.previewImage = item.image;
                this.status_form = item.id;
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            }, edit_sale_method(item) {
                this.selected_method = item.saleMethodId;
                this.selected_person = item.userId;
                this.saleMethodModal = true;

            },
            select_moein(node) {
                var self = this;

                const formData = new FormData();
                var url = "GetAccountTafsiliList";
                formData.append("id", node.id);

                // self.tafzili_list = [];

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            // item.tafzili_list = response.data.data;
                            self.tafsili_list = response.data.data
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                ).catch(function (error) {
                    console.log(error);
                });

            },
            get_lists_groups() {

                var self = this;
                self.items_parent = [];
                self.data_with_children = []

                const formData = new FormData();
                var url = "Get_AllAccountingGroups";

                axios.post(url, formData, {}).then(function (response) {

                        var content_data = response.data;

                        if (content_data.statusCode == 0) {

                            self.accounting_list = response.data.data
                            response.data.data.forEach((val) => {
                                if (val.parentId == 0) {

                                    self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                                        self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                                            self.moein_list.push(val3)

                                        });

                                    });

                                }

                            });
                        } else {
                            self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                        }

                    }
                )
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_childrens_one_sub(parent_id, list) {
                var array = [];
                var self = this;
                list.forEach((val2) => {

                    if (parent_id == val2.parentId) {
                        // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
                        array.push(val2);


                    }
                });
                return array;
            },
            goEditPerson(item) {

                this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

            },
            goToDocuments(item) {

                this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

            },


            get_types() {
                var self = this;


                const formData = new FormData();

                var url = "GetReportNumberList";

                // formData.append('id', "1532");
                //
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var data_get = self.sort_array([], content_data.data
                            , "id", "title");
                        self.types_all = data_get.filter(x => x.typeId == 4);
                        self.types_parent = data_get.filter(x => x.parentId == 0 && x.typeId == 4);
                        self.selected_type_parent = self.types_parent[0].value;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_child_options() {
                var array = [{label: this.$t('select'), value: 0}];
                var newArray = array.concat(this.types_all.filter(x => x.parentId == this.selected_type_parent));
                return newArray
            }

        }
    }

</script>
<style>
    .height-2000  {
        height: 300px !important;
    }
</style>
